<template>
  <div>
    <v-app-bar
        app
        elevation="2"
    >
      <v-app-bar-nav-icon class="d-md-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-img
            alt="Decentral Store Logo"
            class="shrink mr-2"
            contain
            src="@/assets/images/decentralStoreLogo.png"
            transition="scale-transition"
            width="28"
        />
      </div>
      <v-toolbar-title class="mr-10 font-weight-medium">Decentral Store</v-toolbar-title>
<!-- nav bar tags -->
      <div class="d-none d-md-block">
        <v-menu offset-y v-for="(navItem, index) in navItems" :key="index">
          <template v-slot:activator="{ attrs, on }">
            <v-btn depressed small v-bind="attrs" v-on="on" :to="{name: navItem.routeTo}">
              {{navItem.name}}
            </v-btn>
          </template>
        </v-menu>

        <!--    faucet    -->
        <v-menu offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn depressed small v-bind="attrs" v-on="on">Faucet</v-btn>
          </template>
          <v-list>
            <v-list-item-group>
              <v-list-item
                  href="https://goerlifaucet.com/"
                  target="_blank"
              >
                <v-list-item-title>Testnet Gas</v-list-item-title>
              </v-list-item>
              <v-list-item
                  :to="{name: 'stablecoinFaucet'}"
              >
                <v-list-item-title>Stablecoin (Test)</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>

      <v-spacer></v-spacer>

<!-- loggin / logout btn-->
      <v-btn
          color="indigo darken-3"
          dark
          @click="login"
          v-if="!loggedInAccount"
      >
        <span class="mr-2">Connect</span>
        <v-icon
            color="white"
        >
          mdi-wallet-outline
        </v-icon>
      </v-btn>

      <v-btn
          color="indigo darken-3"
          dark
          @click="logout"
          v-if="loggedInAccount"
      >
        <span class="mr-2">Logout</span>
        <v-icon
            color="white"
        >
          mdi-wallet-outline
        </v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        absolute
        left
        temporary
    >
      <v-list
          nav
          dense
      >
        <v-list-item-group
            v-model="group"
        >
          <router-link
              class="router-link"
              v-for="(navItem, index) in navItems"
              :key="index"
              :to="{name: navItem.routeTo}"
          >
            <v-list-item>
              <v-list-item-title>{{navItem.name}}</v-list-item-title>
            </v-list-item>
          </router-link>

          <v-list-group
              :value="false"
          >
            <template v-slot:activator>
              <v-list-item-title>Faucet</v-list-item-title>
            </template>
<!--            <v-list-group-->
<!--                :value="true"-->
<!--                no-action-->
<!--            >-->
<!--              -->
<!--            </v-list-group>-->
            <v-list-item
                href="https://goerlifaucet.com/"
                target="_blank"
                link
            >
              <v-list-item-title>Testnet Gas</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="{name: 'stablecoinFaucet'}">
              <v-list-item-title>Stablecoin (Test)</v-list-item-title>
            </v-list-item>

          </v-list-group>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import metamask from "@/lib/metamask/index"
import store from "@/store"

export default {
  name: 'AppNavbar',

  data: () => ({
    drawer: false,
    group: null,
    navItems: [
      {
        name: "Store Search",
        routeTo: "storeSearch"
      },
      {
        name: "Merchant Panel",
        routeTo: "storeProfileInfo"
      },
      {
        name: "Payment",
        routeTo: "payment"
      }
    ]
  }),

  computed: {
    loggedInAccount: () => store.state.loggedInAccount
  },

  /* eslint-disable */
  methods: {
    async logout() {
      await metamask.auth.logout()
    },
    async login() {
      await this.$router.push({name: 'login'})
    }
  }
};
</script>